import { __decorate } from "tslib";
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { proxy, subscribe } from '@/infrastructure/object-reactive/object-reactive';
import _ from 'lodash';
import { ROOT_FOLDER_ID } from '../constants';
import { treeFind } from '@/infrastructure/utils/array';
let FolderListModelImpl = class FolderListModelImpl {
    constructor() {
        this._folderList = proxy(null);
    }
    get folderList() {
        return _.cloneDeep(this._folderList.value);
    }
    updateFolderList(folderList) {
        this._folderList.value = folderList;
    }
    updateFolderById(folderId, folder) {
        const _folderList = this.folderList;
        const keys = _.keys(folder);
        const targetFolder = this._findFolderById(folderId, _folderList);
        if (targetFolder) {
            _.forEach(keys, (key) => {
                targetFolder[key] = folder[key];
            });
        }
        this.updateFolderList(_folderList);
    }
    addFolder(parentFolderId, folder) {
        const _folderList = this.folderList;
        if (parentFolderId === ROOT_FOLDER_ID) {
            _folderList.push(folder);
            this.updateFolderList(_folderList);
        }
        else {
            const parentFolder = this._findFolderById(parentFolderId, _folderList);
            if (parentFolder) {
                if (!parentFolder.children) {
                    parentFolder.children = [];
                }
                parentFolder.children.push(folder);
            }
            this.updateFolderList(_folderList);
        }
    }
    deleteFolder(folderId) {
        const _folderList = this.folderList;
        const _deleteFolder = (folderId, folderList) => {
            const deleteIndex = _.findIndex(folderList, (folder) => folder.folder_id === folderId);
            if (deleteIndex !== -1) {
                folderList.splice(deleteIndex, 1);
                return true;
            }
            else {
                for (let i = 0; i < folderList.length; i++) {
                    if (!folderList[i].children?.length)
                        continue;
                    if (_deleteFolder(folderId, folderList[i].children)) {
                        break;
                    }
                }
            }
        };
        _deleteFolder(folderId, _folderList);
        this.updateFolderList(_folderList);
    }
    getFolderById(folderId) {
        return this._findFolderById(folderId, this.folderList);
    }
    _findFolderById(folderId, folderList) {
        return treeFind(folderList, 'children', (node) => node.folder_id === folderId);
    }
    subscribe(callback) {
        return subscribe(() => this._folderList.value, (newValue) => {
            callback(newValue);
        });
    }
};
FolderListModelImpl = __decorate([
    injectable()
], FolderListModelImpl);
export { FolderListModelImpl };
